export const redirect = function (
  params: {
    url: string
    [key: string]: string
  }
) {
  const suffix = Object.entries(params).reduce((acc: string[], key) => {
    return [ ...acc,  key[0] + '=' + encodeURIComponent(key[1]) ]
  }, [])

  return useRuntimeConfig().public.REDIRECT_URL + '?' + suffix.join('&')
}